import React, { useState } from "react";
import { Calendar } from "../components/ui/calendar";

export function DatePickerWithRange({ setDateRange }) {
  const [date, setDate] = useState({
    from: new Date(),
    to: new Date(),
  });

  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <Calendar
        initialFocus
        mode="range"
        defaultMonth={date?.from}
        selected={date}
        onSelect={(e) => {
          setDateRange(e);
          setDate(e);
        }}
        numberOfMonths={2}
      />
    </div>
  );
}
